import { useTranslation } from "react-i18next";

import { useTour } from "./useTour";

const SECONDS_PER_STEP = 20;
const SECONDS_PER_MINUTE = 60;

export const getTourMinutes = (stepCount: number) =>
  Math.max(1, Math.ceil((stepCount * SECONDS_PER_STEP) / SECONDS_PER_MINUTE));

export function useTourDuration() {
  const { t } = useTranslation();
  const { stepIds } = useTour();
  return t("tour.duration", { count: getTourMinutes(stepIds.length) });
}
